import { PromptBlueprint } from "@/types/prompt-blueprint";
import { useMutation } from "@tanstack/react-query";
import { dataToPromptBlueprint } from "./utils";

export const useAIPromptAssisstant = () => {
  return useMutation(
    async ({
      prompt,
      blueprint,
    }: {
      prompt: string;
      blueprint: Partial<PromptBlueprint>;
    }) => {
      const response = await fetch(
        "https://hook.us1.make.com/9teowog7bslthsy30xju8rynk4v8s53c",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            prompt_blueprint: JSON.stringify(blueprint),
            customer_prompt: JSON.stringify(prompt),
          }),
        },
      );

      const data = await response.json();

      return dataToPromptBlueprint(data);
    },
  );
};
